import { render } from "./Thorondor-ReglasMonitorizacionView.vue?vue&type=template&id=0f67e354&scoped=true"
import script from "./Thorondor-ReglasMonitorizacionView.vue?vue&type=script&lang=js"
export * from "./Thorondor-ReglasMonitorizacionView.vue?vue&type=script&lang=js"

import "./Thorondor-ReglasMonitorizacionView.vue?vue&type=style&index=0&id=0f67e354&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f67e354"]])

export default __exports__